<template>
  <div id="app">
    <vue-headful
        title="到家 - 在悉尼为您提供更专业的搬家搬运，退房清洁等生活服务"
        description="【到家承诺，你满意再付钱】49万悉尼华人首选，服务不拖拉，价格透明，售后无忧！提供搬家搬运，家具安装，退房清洁，仓储寄存，行李寄存，大件邮寄回国，除虫，除草等生活服务。澳洲首家全自营的生活服务平台，旨在帮助华人轻松解决生活难题。"
        keywords="到家_搬家_澳洲_悉尼_清洁_钟点工_家具_行李回国_消毒_开锁_家具安装_接送机"
    />

    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>

    <div class="pc-view" v-show="!ifPhone()">
      <div class="flex-parent">
        <div class="phone_qr">
          <img class="phone_bg" src="/static/img/index/phoneqr.png">
          <div class="qrcode">
            <qrcode :value="currentURL()" :options="{ width: 200 }"  ></qrcode>
          </div>
        </div>
      </div>
    </div>

    <div class="chat-box" v-if="domainURL !== 'portal-alipay.daojia.com.au'">
      <a href="https://work.weixin.qq.com/kfid/kfcfe22e58292ef89d0?enc_scene=ENC6SXwghg6tyBFjDscQWgMF9LFgqyVvMu3tWrrtKuiuGDmBBHXrwdC6HH4wbPz7eG3kj" target="_blank">
        <i class="icon-chat"></i>
      </a>
    </div>

    <div class="chat-box" v-else>
      <a href="https://about.daojia.com.au/clientservice/" target="_blank">
        <i class="icon-chat"></i>
      </a>
    </div>

    <transition name="fade">
      <v-modal v-if="showModal">
        <div slot="body">
          <div class="modal-title">欢迎使用到家</div>
          <div class="info">亲爱的用户，您已很久没有访问到家<br>为了您的账号安全，请重新登录</div>
          <div class="btn-box">
            <div class="btn active" @click="showModal=false;$router.push('/login?phoneNum='+member_phone);" >立即登录</div>
          </div>
        </div>
      </v-modal>
    </transition>

    <div class="container" v-show="isTabShow">
      <div class="weui-tabbar mtg-tabbar">
        <span @click="goto('/')" class="weui-tabbar__item" v-bind:class="{'weui-bar__item_on': isNaviHome}">
          <div class="weui-tabbar__icon">
            <span class="icon-navi-home" v-show="!isNaviHome"></span>
            <span class="icon-navi-home-active" v-show="isNaviHome"></span>
          </div>
          <p class="weui-tabbar__label">到家</p>
          </span>
          <span @click="goto('/order')" class="weui-tabbar__item" v-bind:class="{'weui-bar__item_on': isNaviOrder}">
            <div class="weui-tabbar__icon">
              <span class="icon-navi-order" v-show="!isNaviOrder"></span>
              <span class="icon-navi-order-active" v-show="isNaviOrder"><span class="path1"></span><span class="path2"></span></span>
            </div>
            <p class="weui-tabbar__label">订单</p>
          </span>
          <span @click="goto('/review')" class="weui-tabbar__item new-iconer" v-bind:class="{'weui-bar__item_on': isNaviReview}">
            <div class="weui-tabbar__icon">
              <span class="icon-review"  v-show="!isNaviReview"></span>
              <span class="icon-review-active"  v-show="isNaviReview"></span>
            </div>
            <p class="weui-tabbar__label">用户评价</p>
            <img src="./assets/img/global/nav-new.svg">
          </span>
          <span @click="goto('/service/joinus')" class="weui-tabbar__item" v-bind:class="{'weui-bar__item_on': isNaviJoin}">
            <div class="weui-tabbar__icon">
              <span class="icon-join"  v-show="!isNaviJoin"></span>
              <span class="icon-join-active"  v-show="isNaviJoin"></span>
            </div>
            <p class="weui-tabbar__label">合作加盟</p>
          </span>
          <!-- <a href="javascript:void(0)" @click="$router.push('/contact')" class="weui-tabbar__item" v-bind:class="{'weui-bar__item_on': isNaviSupport}"> -->
          <!-- <a href="javascript:void(0)" class="weui-tabbar__item" id="chatnow">
            <div class="weui-tabbar__icon">
              <span class="icon-navi-support" v-show="!isNaviSupport"></span>
              <span class="icon-navi-support-active" v-show="isNaviSupport"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
            </div>
            <p class="weui-tabbar__label">客服</p>
          </a> -->
          <span @click="goto('/profile')" class="weui-tabbar__item" v-bind:class="{'weui-bar__item_on': isNaviUser}">
            <div class="weui-tabbar__icon">
              <span class="icon-navi-user" v-show="!isNaviUser"></span>
              <span class="icon-navi-user-active" v-show="isNaviUser"></span>
            </div>
            <p class="weui-tabbar__label">我的</p>
          </span>
      </div>
    </div>

  </div>
</template>


<script>
import qs from 'qs'

export default {
  name: 'App',
  data () {
    return {
      window: {
        width: 0,
        height: 0
      },
      showModal:false,
      member_phone:'',
      isTabShow: true,
      isNaviHome: false,
      isNaviOrder: false,
      isNaviSupport: false,
      isNaviUser: false,
      isNaviJoin: false,
      isNaviReview: false
    }
  },
  methods: {
    naviSwitch(tab){
      this.isNaviHome=false;
      this.isNaviOrder=false;
      this.isNaviSupport=false;
      this.isNaviUser=false;
      this.isNaviJoin=false;
      this.isNaviReview=false;
      switch (tab) {
        case "home":
          this.isNaviHome = true
          break;
        case "order":
          this.isNaviOrder = true
          break;
        case "support":
          this.isNaviSupport = true
          break;
        case "user":
          this.isNaviUser = true
          break;
        case "join":
          this.isNaviJoin = true
          break;
        case "review":
          this.isNaviReview = true
          break;
        default:
          console.log("reset all tabs");
      }
    },
    updateToken(){
      if(this.checkLogin()){
        if (localStorage.hasOwnProperty('tokenExpire') && localStorage.tokenExpire) {
          if(Math.floor(Date.now() / 1000)-localStorage.tokenExpire > 0){
            this.member_phone = localStorage.member_phone;
            this.clearLoginLS();
            this.showModal = true;
          }
          else{
            let tokenObject = {token:localStorage.token};
            this.axios.post(this.apiURL()+'/globals/verify_login', qs.stringify(tokenObject))
            .then(function (response) {
              if(response.data.error_code==0){
                localStorage.tokenExpire = Math.floor(Date.now() / 1000) + 60*60*24*4.5;
              }
              else{
                this.member_phone = localStorage.member_phone;
                this.clearLoginLS();
                this.showModal = true;
              }
            })
            .catch(function (error) {
                console.log(error)
            });
          }
        }
        else{
          let tokenObject = {token:localStorage.token};
          this.axios.post(this.apiURL()+'/globals/verify_login', qs.stringify(tokenObject))
          .then(function (response) {
            if(response.data.error_code==0){
              localStorage.tokenExpire = Math.floor(Date.now() / 1000) + 60*60*24*4.5;
            }
            else{
              this.member_phone = localStorage.member_phone;
              this.clearLoginLS();
              this.showModal = true;
            }
          })
          .catch(function (error) {
              console.log(error)
          });
        }
      }
      let expiration = Math.floor(Date.now() / 1000) + 60*60*24*4;

    },
    ifPhone(){
      if(this.window.width>7680){
        return false;
      }
      else{
        return true;
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    currentURL() {
      return window.location.href;
    }
  },
  watch:{
    $route (to, from){
      if(
        to.path.includes('move') ||
        to.path.includes('baggage') ||
        to.path.includes('organization') ||
        to.path.includes('address-manage') ||
        to.path.includes('order-') ||
        to.path.includes('clean') ||
        to.path.includes('household-')||
        to.path.includes('suburb')||
        to.path.includes('service/form')||
        to.path.includes('order/pay-') ||
        to.path.includes('contact') ||
        to.path.includes('storage') ||
        to.path.includes('general') ||
        to.path.includes('new-password') ||
        to.path.includes('payment-') ||
        to.path.includes('misc') ||
        to.path.includes('pest') ||
        to.path.includes('terms-') ||
        to.path.includes('refund-') ||
        to.path.includes('warehouse-') ||
        to.path.includes('coupon-') ||
        to.path.includes('new-user-survey')
      ){
        this.isTabShow = false;
      }
      else{
        this.isTabShow = true;
      }
      switch (to.path) {
        case "/":
          this.naviSwitch('home');
          break;
        case "/reg":
          this.naviSwitch('user');
          break;
        case "/login":
          this.naviSwitch('user');
          break;
        case "/order":
          this.naviSwitch('order');
          break;
        case "/profile":
          this.naviSwitch('user');
          break;
        case "/profile-login":
          this.naviSwitch('user');
          break;
        case "/service/joinus":
          this.naviSwitch('join');
          break;
        case "/review":
          this.naviSwitch('review');
          break;
        case "/review/gallery":
          this.naviSwitch('review');
          break;
        default:
          this.naviSwitch('other');
      }
    }
  },
  mounted: function () {
    this.updateToken();
    let currentPath = this.$route.path;
    let that = this;
    this.$router.onReady(function(){
      if(currentPath.includes('move') ||
        currentPath.includes('baggage') ||
        currentPath.includes('organization') ||
        currentPath.includes('clean') ||
        currentPath.includes('address-manage') ||
        currentPath.includes('household') ||
        currentPath.includes('suburb') ||
        currentPath.includes('service/form') ||
        currentPath.includes('order-') ||
        currentPath.includes('order/pay-') ||
        currentPath.includes('contact') ||
        currentPath.includes('storage') ||
        currentPath.includes('general') ||
        currentPath.includes('warehouse-') ||
        currentPath.includes('new-password') ||
        currentPath.includes('/payment-') ||
        currentPath.includes('misc') ||
        currentPath.includes('pest') ||
        currentPath.includes('refund-') ||
        currentPath.includes('coupon-') ||
        currentPath.includes('terms-') ||
        currentPath.includes('new-user-survey')
      ){
        that.isTabShow = false;
      }
      else{
        that.isTabShow = true;
      }
      switch (currentPath) {
        case "/":
          that.naviSwitch('home');
          break;
        case "/reg":
          that.naviSwitch('user');
          break;
        case "/login":
          that.naviSwitch('user');
          break;
        case "/order":
          that.naviSwitch('order');
          break;
        case "/profile":
          that.naviSwitch('user');
          break;
        case "/profile-login":
          that.naviSwitch('user');
          break;
        case "/service/joinus":
          that.naviSwitch('user');
          break;
        case "/review":
          that.naviSwitch('review');
          break;
        default:
          that.naviSwitch('other');
      }

    })
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    if(this.window.width>1024){
      window.location.href="/pc/?path="+this.$route.fullPath;
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },

}
</script>



<style lang="scss">
@import "./assets/css/weui.min.css";
@import "./assets/css/base.scss";
@import "./assets/css/icomoon/style.css";

#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding-bottom:50px;
}
.pc-view{
  width:100%;
  height:100%;
  position:fixed;
  top:0;
  left:0;
  background:#fff;
  background-image: url('/static/img/index/pcbg.jpg') ;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  z-index:999;
}
.weui-tabbar__icon{
    display: inline-block;
    width: 30px;
    font-size: 30px;
    height: 30px;
    line-height: 28px;
}

.weui-tabbar__item.weui-bar__item_on .weui-tabbar__icon, .weui-tabbar__item.weui-bar__item_on .weui-tabbar__icon>i, .weui-tabbar__item.weui-bar__item_on .weui-tabbar__label{
    color:#fe9567;
}
  
.weui-tabbar{
    background:#fff;
    position:fixed;
}
.info{
	font-weight:100;
	text-align:center;
	padding-top:4px;
}
.flex-parent{
  height:100%;
	display: flex;
	justify-content:center;
	align-items:center;
}
.phone_qr{
  position:relative;
}
.phone_bg{
  width:340px;
}
.qrcode{
  position:absolute;
  top:260px;
  left:68px;
}
.mtg-tabbar{
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.new-iconer{
  position:relative;
  img{
    position:absolute;
    top:-2px;
    right:6px;
  }
}
.chat-box {
  i{
    color:#fff;
  }
  a {
    display: flex; /* 使得<a>标签成为flex容器 */
  }
  background-color: #ff7f00; /* 橙色背景 */
  border-radius: 50%; /* 圆形 */
  width: 54px; /* 宽度 */
  height: 54px; /* 高度 */
  display: flex; /* 使得内容居中 */
  align-items: center;
  justify-content: center;
  font-size:32px;
  position:fixed;
  bottom:112px;
  right:18px;
  z-index:999;
  box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue